import { LIBRARY_INFO } from 'components/assets/libraries'
import { SearchIcon } from 'components/icons'
import Input from 'components/inputs/input'
import * as SubNavigation from 'components/layout/sub-navigation'
import { useCurrentUser } from 'context/current-user-context'
import { useRouter } from 'next/router'
import { FC } from 'react'

type Props = {
  search?: string
  searchPlaceholder?: string
  setSearch?: (search: string) => void
  searchDisabled?: boolean
}

export const AssetTabs: FC<Props> = ({
  search,
  searchPlaceholder,
  setSearch,
  searchDisabled = false,
}) => {
  const router = useRouter()
  const currentUser = useCurrentUser()
  const basePath = router.query.assetType
    ? String(router.query.assetType)
    : router.asPath.split('/')[1]
  return (
    <div className="flex flex-col-reverse gap-2 lg:flex-row lg:items-center">
      <SubNavigation.List className="hide-scrollbar mb-0 overflow-x-scroll border-b-0">
        <div className="flex">
          {LIBRARY_INFO.filter(
            (info) =>
              !info.hidden &&
              (!info.featureFlag || currentUser.hasFeature(info.featureFlag)),
          ).map((info) => (
            <SubNavigation.Link
              key={info.basePath}
              asLink
              isActive={basePath === info.basePath}
              href={'/' + info.basePath}>
              {info.label}
            </SubNavigation.Link>
          ))}
        </div>
      </SubNavigation.List>
      {Boolean(setSearch) && (
        <Input
          type="search"
          name="itemSearch"
          id="tiemSearch"
          value={search}
          setValue={setSearch}
          className="mr-0 mt-0 w-56 lg:ml-auto"
          containerClassName="h-8 mt-0 text-sm"
          placeholder={searchPlaceholder}
          icon={SearchIcon}
          disabled={searchDisabled}
        />
      )}
    </div>
  )
}
